import React, { useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router-dom';
import { api_url } from '../../constant/constant';
import { Button } from 'react-bootstrap';
import { showToast } from '../../Components/ShowToast/ToastNotification';

const PreviewCertificate = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const [htmlContent, setHtmlContent] = useState('');
  const [loading, setLoading] = useState(false);

  const fetchCertificatePreview = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("userToken");
      const response = await fetch(`${api_url}/certificate-templates/preview/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
      });

      if (response.ok) {
        const html = await response.text();
        setHtmlContent(html);
      } else {
        showToast(t("errorfetchingdata"), "error");
      }
    } catch (error) {
      console.error("Error fetching certificate preview:", error);
      showToast(t("somethingwentwrong"), "error");
    } finally {
      setLoading(false);
    }
  };

  // Create blob URL from HTML content for iframe
  const iframeSrc = useMemo(() => {
    if (!htmlContent) return '';
    const blob = new Blob([htmlContent], { type: 'text/html' });
    return URL.createObjectURL(blob);
  }, [htmlContent]);

  // Cleanup blob URL on unmount or when content changes
  useEffect(() => {
    return () => {
      if (iframeSrc && iframeSrc.startsWith('blob:')) {
        URL.revokeObjectURL(iframeSrc);
      }
    };
  }, [iframeSrc]);

  useEffect(() => {
    if (id) {
      fetchCertificatePreview();
    }
  }, [id]);

  return (
    <div className="Certificate" style={{ border: "1px solid #EAEAEA", borderRadius: "10px", padding: "26px 26px", marginLeft: "19px", marginTop: "20px" }}>
      <div className="d-flex justify-content-between mb-3">
        <div className="pageTitle">{t('Preview')} {t('CertificateManagement')}</div>
        <Button variant="primary" onClick={() => navigate(-1)}>{t('Back')}</Button>
      </div>

      {loading ? (
        <div className='d-flex justify-content-center align-items-center my-5'>
          <div className='spinner-border' role='status' style={{
            borderTopColor: "#6897CB",
            borderBottomColor: "#6897CB",
            borderLeftColor: "#6897CB",
            marginTop: "50px"
          }}></div>
        </div>
      ) : (
        <div className="certificate-preview-container" style={{ 
          border: "1px solid #EAEAEA", 
          borderRadius: "10px", 
          padding: "20px",
          backgroundColor: "#fff",
          minHeight: "400px"
        }}>
          {htmlContent && iframeSrc && (
            <iframe
              src={iframeSrc}
              style={{
                width: "1123px",
                height: "794px",
                border: "none",
                borderRadius: "5px"
              }}
              title="Certificate Preview"
            />
          )}
        </div>
      )}
    </div>
  );
};

export default PreviewCertificate;

